var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mp-page mp-page--small"},[_c('h4',{staticClass:"mp-section-title"},[_vm._v("About")]),_c('p',[_vm._v("Meal Planner #"+_vm._s(_vm.application.version)+" "+_vm._s(_vm.application.date))])])}
var staticRenderFns = []

export { render, staticRenderFns }